import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useUserStore = create(
  persist(
    (set) => ({
      // User data
      name: 'زائر',
      points: 0,
      level: 1,
      streak: 0,
      lastVisit: null,

      // Progress tracking
      completedLessons: [],
      earnedBadges: [],
      mapInteractions: 0,
      gamesWon: 0,

      // Actions
      setName: (name) => set({ name }),

      addPoints: (amount) =>
        set((state) => {
          const newPoints = state.points + amount;
          const newLevel = Math.floor(newPoints / 50) + 1;

          // Check if leveled up
          const leveledUp = newLevel > state.level;

          return {
            points: newPoints,
            level: newLevel,
            leveledUp
          };
        }),

      completeLesson: (lessonId) =>
        set((state) => ({
          completedLessons: [...state.completedLessons, lessonId]
        })),

      earnBadge: (badgeId) =>
        set((state) => {
          if (state.earnedBadges.includes(badgeId)) return state;
          return {
            earnedBadges: [...state.earnedBadges, badgeId]
          };
        }),

      incrementMapInteractions: () =>
        set((state) => ({
          mapInteractions: state.mapInteractions + 1
        })),

      incrementGamesWon: () =>
        set((state) => ({
          gamesWon: state.gamesWon + 1
        })),

      updateStreak: () =>
        set((state) => {
          const today = new Date().toDateString();
          const lastVisit = state.lastVisit ? new Date(state.lastVisit).toDateString() : null;

          if (lastVisit === today) {
            return state; // Already visited today
          }

          const yesterday = new Date();
          yesterday.setDate(yesterday.getDate() - 1);
          const yesterdayStr = yesterday.toDateString();

          const newStreak = lastVisit === yesterdayStr ? state.streak + 1 : 1;

          return {
            streak: newStreak,
            lastVisit: new Date().toISOString()
          };
        }),

      resetProgress: () =>
        set({
          points: 0,
          level: 1,
          completedLessons: [],
          earnedBadges: [],
          mapInteractions: 0,
          gamesWon: 0,
          streak: 0
        })
    }),
    {
      name: 'kunuz-misr-user'
    }
  )
);
